<template>
<div class="_modal-message">
  <CAlert :show.sync="dismissCountDown" color="success">
    <CRow class="_alert-message-header">
        <h4 class="alert-heading">{{modal.title}}</h4> 
        <CButton size="sm" color="success" @click="close">
          <i class="fas fa-times"></i>
        </CButton>
    </CRow>
    <hr>
    <!-- Subtitle -->
    <CRow class="_modal-message-header">
      <CCol sm="12">
        <h6>{{modal.subtitle}}</h6>
      </CCol>
    </CRow>

    <!-- Detail -->
    <CRow class="_modal-message-body">
      <CCol sm="12">
        <transition name="fade">
          <CCard class="_card">
            <CCardHeader class="_card-header-group _transparent " @click="isCollapsed = !isCollapsed">
              <Label class="_text-success">Detalhes</Label>
              <div class="card-header-actions">
                <CLink class="card-header-action btn-minimize mr-2 _text-success">
                  <CIcon :name="`cil-chevron-${isCollapsed ? 'top' : 'bottom'}`"/>
                </CLink>
              </div>
            </CCardHeader>
            <CCardBody>
              <CCollapse color="success" :show="isCollapsed" :duration="400">
                <p class="text-black">
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
              </CCollapse>
            </CCardBody>   
          </CCard>
        </transition>
      </CCol>
    </CRow> 
    <CRow>
      <CCol sm="12">
        <CProgress color="success" :max="dismissSecs" :value="dismissCountDown" height="4px"/>
        <p class="_text-success pt-1">Fechando em {{ dismissCountDown }} segundos...</p>
      </CCol>
    </CRow>
  </CAlert>
</div>
</template>


<script>
import { closeMessage } from "@/js/app/messages.js";

export default {
  name: "Alert",
  props: {
    modal: Object
  },
  components: {},
  computed: {},
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 10,

      isCollapsed: this.modal.isCollapsed,
      iconCollapsed: null,

    };
  },
  methods: {
    close() {
      closeMessage()      
    },
    /*countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },*/
  },
  watch: {
    /*dismissCountDown: {
      immediate: true,
      handler(dismissCountDown) {
        if(!dismissCountDown > 0) {
          this.close()          
        }
      }
    }*/
  }
};
</script>